import Carousel from '../components/Carousel';
import Slider from '../components/Slider';
import { $ } from '../util/DOM';

const getLinkHtml = (el) => {
  const qs = el.getAttribute('data-link-content');
  if (!qs) {
    return '';
  }
  const content = el.querySelector(qs);
  if (!content) {
    return '';
  }
  return content.innerHTML;
};

const sliderControlComponents = {
  arrows: (slider) => $.render('div', {
    className: 'slider-controls__arrows',
    children: [
      $.render('button', {
        type: 'button',
        className: 'prev',
        attrs: { 'aria-label': 'Voltar slide' },
        innerHTML: /* html */ `
        <svg width="13" height="29" viewBox="0 0 13 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.0001 27.1907C12.9997 26.7096 12.8259 26.2483 12.517 25.9084L4.09469 16.6275C3.83976 16.3467 3.63754 16.0132 3.49957 15.6463C3.3616 15.2793 3.29059 14.886 3.29059 14.4887C3.29059 14.0915 3.3616 13.6982 3.49957 13.3312C3.63754 12.9642 3.83976 12.6308 4.09469 12.35L12.5061 3.07516C12.806 2.73293 12.972 2.27456 12.9682 1.79879C12.9645 1.32302 12.7913 0.867907 12.486 0.531472C12.1807 0.195038 11.7677 0.00420292 11.3359 6.85951e-05C10.9041 -0.00406573 10.4882 0.178832 10.1776 0.509369L1.76625 9.77693C0.635258 11.0257 6.10352e-05 12.7178 6.10352e-05 14.4821C6.10352e-05 16.2463 0.635258 17.9385 1.76625 19.1872L10.1886 28.4681C10.4186 28.7217 10.7115 28.8945 11.0306 28.9648C11.3496 29.0351 11.6803 28.9996 11.9811 28.863C12.2819 28.7263 12.5391 28.4946 12.7205 28.1969C12.9018 27.8993 12.9991 27.5492 13.0001 27.1907Z" fill="#333333"/>
        </svg>`,
        events: {
          click: () => {
            slider.goPrev();
          },
        },
      }),
      $.render('button', {
        type: 'button',
        className: 'next',
        attrs: { 'aria-label': 'Avançar slide' },
        innerHTML: /* html */ `
        <svg width="13" height="29" viewBox="0 0 13 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.10352e-05 27.1907C0.00044538 26.7096 0.174189 26.2483 0.483094 25.9084L8.90543 16.6275C9.16036 16.3467 9.36258 16.0132 9.50055 15.6463C9.63852 15.2793 9.70953 14.886 9.70953 14.4887C9.70953 14.0915 9.63852 13.6982 9.50055 13.3312C9.36258 12.9642 9.16036 12.6308 8.90543 12.35L0.494072 3.07516C0.194112 2.73293 0.0281332 2.27456 0.031885 1.79879C0.0356369 1.32302 0.208819 0.867907 0.514131 0.531472C0.819443 0.195038 1.23246 0.00420292 1.66422 6.85951e-05C2.09598 -0.00406573 2.51194 0.178832 2.82251 0.509368L11.2339 9.77693C12.3649 11.0257 13.0001 12.7178 13.0001 14.4821C13.0001 16.2463 12.3649 17.9385 11.2339 19.1872L2.81153 28.4681C2.58157 28.7217 2.28859 28.8945 1.96957 28.9648C1.65055 29.0351 1.31979 28.9996 1.01903 28.863C0.718264 28.7263 0.460974 28.4946 0.279625 28.1969C0.0982769 27.8993 0.000996689 27.5491 6.10352e-05 27.1907Z" fill="#333333"/>
        </svg>`,
        events: {
          click: () => {
            slider.goNext();
          },
        },
      }),
    ],
  }),
  counters: (slider) => {
    const children = slider.children.map((el, i) => $.render('button', {
      type: 'button',
      textContent: i + 1,
      attrs: { 'aria-label': `Ver o slide ${i + 1}` },
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__counters',
      children,
    });
  },
  links: (slider) => {
    const children = slider.children.map((el, i) => $.render('div', {
      innerHTML: getLinkHtml(el),
      tabindex: '-1',
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__links',
      children,
    });
  },
};

const generateControls = (slider, keys) => keys.map((key) => {
  if (!(key in sliderControlComponents)) {
    // eslint-disable-next-line no-console
    console.warn(`Opção de controle inválida: ${key}. As opções disponíveis são ${
      Object.keys(sliderControlComponents).join(', ')
    }`);
    return null;
  }
  return sliderControlComponents[key](slider);
});

const setSliderControls = (slider, controlOptions) => {
  if (!controlOptions) {
    return;
  }
  const controlKeys = controlOptions.trim().split(' ');
  if (!controlKeys.length) {
    return;
  }

  const container = $.render('div', {
    className: 'slider-controls__container',
    children: generateControls(slider, controlKeys),
  });

  slider.container.insertAdjacentElement('afterEnd', container);
};

const createSlider = (container, type) => {
  const play = container.hasAttribute('data-play');
  const interval = container.getAttribute('data-interval') || 3000;
  const height = container.getAttribute('data-height');
  const controls = container.getAttribute('data-controls');

  const slider = (
    type === 'carousel'
      ? new Carousel(container, { interval })
      : new Slider(container, { interval })
  );

  if (play) {
    slider
      .on('mouseover', () => slider.pause())
      .on('mouseout', () => slider.play())
      .play();
  }

  if (height) {
    slider.container.style.height = height;
  }

  if (controls) {
    setSliderControls(slider, controls);
  }

  return slider;
};

const createCarousel = (container) => {
  createSlider(container, 'carousel');
};

const initSliders = () => {
  $('.slider').forEach(createSlider);
  $('.carousel').forEach(createCarousel);
};

export default initSliders;
